import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import CustomDateModal from '../../CustomModal/CustomDateModal';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import NoDataFound from '../../constants/NoDataFound';


const ChallanMaster = (props) => {

    //----------- REDUCE TOOLKIT -------
    const vendorState = useSelector((state) => state.vendorState);
    const branchState = useSelector((state) => state.branchState);      const [errorMessage, setErrorMessage] = useState({});
        
            const { user } = useSelector((state) => state.authState);
        
            const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
                useVendorBranch(user);
        
            const [selectionData, setSelectionData] = useState({
                vendor_id: "",
                branch_id: "",
            });
    

  const sessionData = useSelector((state) => state.sessionState);

    const [challanTable, setChallanTable] = useState([]);
    const [searchKey, setSearchkey] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showDateModel, setShowDateModel] = useState(false);
    const [allDateSelected, setAllDateSelected] = useState(true);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination


    const location = useLocation();
    const navigate = useNavigate();

    const getChallanData = async (flag, search, page = 1, limit = 10, venderMstId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

         //   console.log("Selected sessionData.session_year:", sessionData.session_year);

            // Build query params conditionally
            let queryParams = `flag=${flag ? flag : props.irFlag}&pageNo=${page}&pageSize=${limit}`;
            sessionData.session_year && (queryParams += `&session=${encodeURIComponent(sessionData.session_year)}`);
            if (search) queryParams += `&searchKey=${encodeURIComponent(search ? search : searchKey)}`;
            if (startDate) queryParams += `&startDate=${encodeURIComponent(startDate)}`;
            if (endDate) queryParams += `&endDate=${encodeURIComponent(endDate)}`;
            
            
            const vendorId = selectionData.vendor_id;
            const branchId = selectionData.branch_id;
            queryParams += `&venderMasterId=${vendorId}`;
            queryParams += `&branchMasterId=${branchId}`;

            // const response = await apiService.get(`/api/IssueReceipt/allchallan?flag=${flag}`, config)
            const response = await apiService.get(`/api/IssueReceipt/allchallan?${queryParams}`, config);
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                setChallanTable(response.issueReceiptMasterDetailData)
                setTotalPage(response.totalPages)

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    useEffect(() => {
        getChallanData(props?.irFlag, "", 1, 10);
    }, [!challanTable, props?.irFlag]);

  const onHandleChallan = () => {
    const routeMap = {
        IC: "/add_challan_issue",
        SC: "/add_challan_sale",
        PC: "/add_challan_purchase",
        PIC: "/add_challan_performa",
        POR: "/add_purchase_order_receive",
        POI: "/add_purchase_order"
    };

    const route = routeMap[props?.irFlag];

    if (route) {
        navigate(route);
    } else {
        toast.error("Invalid challan type!!");
    }
};

    const onHandleDeleteChallan = async (challanId) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`/api/IssueReceipt/delete?challanId=${challanId}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getChallanData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    }

const onHandleEditChallan = (challanId) => {
    const findArrayData = challanTable.find(e => e.id === challanId);

    if (!findArrayData) return;

    const routeMap = {
        IC: '/add_challan_issue',
        SC: '/add_challan_sale',
        PC: '/add_challan_purchase',
        PIC: '/add_challan_performa',        
        POR: "/add_purchase_order_receive",
        POI: "/add_purchase_order"
    };

    const route = routeMap[props?.irFlag];

    if (route) {
        navigate(route, {
            state: {
                challanId: findArrayData.id,
                partyId: findArrayData.pcode
            }
        });
    }else {
        toast.error("Invalid challan type!!");
    }
};


    const onHandleSearchKey = (e) => {
        let search = e.target.value;
        setSearchkey(search);
        getChallanData(props?.irFlag, search, 1, 10)
    }
    const handleApply = () => {
        setShowDateModel(true);
    }

    const handlePageClick = (data) => {
        getChallanData(props?.irFlag, "", data.selected + 1, 10)
    };

    // =======================  VENDER & BRANCH =================

    const [selectedVendorId, setSelectedVendorId] = useState("");
    const [selectedBranchId, setSelectedBranchId] = useState("");

    // Handle vendor selection change
    const selectVendorFilter = (e) => {

        let value = e.target.value
        if (!value) {
            setSelectedVendorId(value);
            setSelectedBranchId("");
        } else {
            setSelectedVendorId(value);
            setSelectedBranchId("");
            // getChallanData(1, 10, "", value)
            getChallanData(props?.irFlag, "", 1, 10);

        }
    };


    // Handle branch selection change
    const selectbranchFilter = (e) => {
        setSelectedBranchId(e.target.value);
    };

     useEffect(() => {
                  const canLoad = conditionalDataLoad({
                      hasMultiBranch,
                      hasSingleBranch,
                      isSuperAdmin,
                      isAdmin,
                      vendorId: selectionData.vendor_id,
                      branchId: selectionData.branch_id,
                  });
          
                  if (canLoad) {
                      getChallanData(props?.irFlag, "", 1, 10);
                  }
                  // eslint-disable-next-line react-hooks/exhaustive-deps
              }, [selectionData]);

    // useEffect(() => {
    //     getChallanData(props?.irFlag, "", 1, 10);
    // }, [selectedVendorId, selectedBranchId])


    // useEffect(() => {

    //     if (user.user_profile != "superadmin" && selectedVendorId && selectedBranchId) {
    //         getChallanData(props?.irFlag, "", 1, 10);
    //     } else if (user.user_profile == "superadmin") {
    //         getChallanData(props?.irFlag, "", 1, 10);
    //     }

    //     if (vendorState?.vendors?.length == 1) {
    //         setSelectedVendorId(vendorState.vendors[0].id);
    //     }

    //     if (branchState?.branches?.length == 1) {
    //         setSelectedBranchId(branchState.branches[0].id);
    //     }
    // }, [selectedVendorId, selectedBranchId])

    return (
        <>
         <div className="text-right mb-2">
                                                <Button color="success" onClick={onHandleChallan} >
                                                    <i className="bi bi-plus-circle mr-2"></i>
                                                    New
                                                </Button>
                                            </div>
                                    <VendorBranchSelector
                                        user={user}
                                        selectionData={selectionData}
                                        setSelectionData={setSelectionData}
                                        errorMessage={errorMessage}
                                        accessButton={true}
                                    />


                <Card className='bg-white pd-10 card-box mb-30'>
                    {/* 
                    <Col style={{justifyContent:"flex-end", alignItems:'flex-end', display:"flex"}}>

                        <Button color="success" onClick={onHandleChallan} style={{ }}>
                            Add New
                        </Button>
                    </Col> */}



                    <CardTitle
                        tag="h6"
                        className="border-bottom p-3 mb-0 sticky-top"
                    >


                        <Row className="align-items-center g-2 mb-2">
                            <Col xs={12} className="d-flex justify-content-between align-items-center">
                                {/* Title aligned left */}
                                <div className="d-flex align-items-center">
                                    <i className="bi bi-card-text mr-2"></i>
                                    {props?.title}
                                </div>

                            </Col>
                        </Row>

                        <Row style={{ display: "flex", justifyContent: "start" }}>


                            {/* Search and Filter in same line, centered */}
                            <Col xl={12} className="d-flex justify-content-center justify-content-md-end align-items-center gap-2">

                                <Input

                                    id="search"
                                    name="search"
                                    placeholder="Search..."
                                    type="text"
                                    // style={{ minWidth: '250px' }}
                                    onChange={(e) => onHandleSearchKey(e)}
                                />
                                <Button color="info" onClick={handleApply}>
                                    <i className="bi bi-funnel mr-1"></i>
                                    <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Filter</p>

                                </Button>
                            </Col>

                        </Row>

                    </CardTitle>


                    <CardBody className="">
                        <Table hover striped responsive>
                            <thead>
                                <tr>
                                    {/* <th>S.no.</th> */}
                                    <th>Bill No.</th>
                                    {(user.user_profile == "superadmin" || branchState.length) && <th>Branch/Vendor Name</th>}

                                    {/* <th>Action</th> */}
                                    <th>Bill Date</th>
                                    <th>Party  Name</th>
                                    <th>Qty</th>
                                    <th>Amt</th>

                                </tr>
                            </thead>
                            <tbody>
                                {challanTable.length > 0 ? (
                                    challanTable.map((item, index) => (
                                        <tr key={index}>
                                            <th scope="row">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <span className="ms-2 fw-bold">{item.manual_billno}</span>
                                                    <Button
                                                        color="warning"
                                                        size="sm"
                                                        className="mt-1 ms-2"
                                                        onClick={() => onHandleEditChallan(item.id)}
                                                    >
                                                        <i className="bi bi-pencil mr-1"></i> Edit
                                                    </Button>
                                                </div>
                                            </th>

                                            {(user.user_profile === "superadmin" || branchState.length > 0) && (
                                                <td>
                                                    <strong>{item.branch_name}</strong>
                                                    <br />
                                                    {item.vender_name}
                                                </td>
                                            )}

                                            <td>{item.bill_date?.split("T")[0]}</td>
                                            <td>
                                                {item.pname}{" "}
                                                <span className="text-muted">({item.agr_code_old})</span>
                                            </td>
                                            <td>{item.tot_qty}</td>
                                            <td>₹{item.final_amount}</td>
                                        </tr>
                                    ))
                                ) : (
                                     <NoDataFound colSpan={6}/>
                                                 
                                )}
                            </tbody>
                        </Table>
                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>

                </Card>

            {/* Data Filter */}
            <CustomDateModal

                filterFlag="sale_report"

                showDateModel={showDateModel}
                setShowDateModel={setShowDateModel}

                allDateSelected={allDateSelected}
                setAllDateSelected={setAllDateSelected}

                startDate={startDate}
                setStartDate={setStartDate}

                endDate={endDate}
                setEndDate={setEndDate}

                // handleCloseModel={handleCloseModel}
                // handleFilterDate={handleFilterDate}
                getChallanData={getChallanData}
            />

        </>
    )
}

export default ChallanMaster